import { languageMessage } from "../types/language";
import { Messages } from "../react-intl/Translations";
import { ClampexType } from "../types/types";
import { ProductInputData, Clampex } from "./product/productTypes";

let resolvedLang = navigator.language.split(/[-_]/)[0];

if(resolvedLang.includes('de') || resolvedLang.includes('en')) {
    resolvedLang = navigator.language.split(/[-_]/)[0].toString();
} else {
    resolvedLang = 'en';
}

export const DefaultLanguageState: LanguageState = {
    //Read language from browser navigator
    currentLanguage: Messages.filter(lang => lang.langcode === resolvedLang)[0],

}




export const DefaultProductState: ProductState = {
    currentProduct: { 
        clampexType: {
            image: "",
            assemblyManualDE:"",
            assemblyManualEN:"",
            catalogueURLEN:"",
            catalogueURLDE:"",
            size:0
        },
        type: ClampexType.KTR100, 
        c_VALUES: [],
        sizes: [],
        materials: []
    },
    /* productInputData: {
       
        hubInnerDiameter: 47,
        hubOuterDiameter: 70.5,
        torque: 2,
        axialForce: 2,
        rotationSpeed: 2,
        yieldStrengthShaft: 350,
        shaftDiameter_d: 17,
        shaftInnerDiameter_diw: 1,
        yieldStrengthHub: 350,
        materialDensityHub: 7.85,
        screwBoltingTorqueOverwritePercentage: 0,
        c_value: 0.8,
       
    },,*/
       productInputData: { 
           /*
            screwBoltingTorqueOverwritePercentage: 0,
            hubInnerDiameter: null,
            hubOuterDiameter: null,
            torque: null,
            axialForce: null,
            rotationSpeed: null,
            yieldStrengthShaft: null,
            shaftDiameter_d: null,
            shaftInnerDiameter_diw: null,
            yieldStrengthHub: null,
            c_value: null,*/
    },
    loading: false
}

export interface LanguageState {
    currentLanguage: languageMessage
}

export interface ProductState {
    currentProduct: Clampex
    productInputData: ProductInputData
    loading: boolean
}

export interface ApplicationState {
    language: LanguageState,
    product: ProductState,
    directURL: Boolean
}
